export const initialState = {
  searchResult: null,
  selectedResult: null,
  levels: [],
  classMates: null,
  TeacherSchoolClass: null,
  allAssignment: null,
  guidedPathUnits: [],
  assignmentsRes: null,
};